// import styles
import '../styles/Footer.css';

// Function to Display Footer
function Footer() {
    return (
        <footer>
            <p>Created at <a href="https://junocollege.com/">Juno College</a></p>
        </footer>
    )
}

export default Footer;